export const en = {
    'button-cancel': 'Cancel',
    'button-submit': 'Apply',
    'highest-bid': 'Attention: an overly high bid has been stopped'
};
